export default __webpack_public_path__ + "static/media/empty-box.d7508c0c.jpg";